import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Card = styled(Box)(({ theme }) => ({
  padding: '18px 20px',
  borderRadius: '10px',
  backgroundColor: '#FFFFFF',
  border: `1px solid ${theme.palette.divider}`,
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  minHeight: '320px',
}));

export const Title = styled(Typography)(({ theme }) => ({
  fontSize: '13px',
  fontWeight: 700,
  textTransform: 'uppercase',
  color: theme.palette.text.secondary,
  letterSpacing: '0.04em',
}));

export const Body = styled(Box)(() => ({
  position: 'relative',
  flex: 1,
  minHeight: '260px',
}));
